define.alias("shared/components/shared/collapsable-info-card", "calendar/components/shared/collapsable-info-card");